import FormattedDate from './formatted-date';

export default FormattedDate;
